import React, { useState } from "react";
import Contact from "../contact";
import arrowIcon from "../../images/home/arrow-icon.svg";
import ellipticalIcon from "../../images/individual/ellipticalIcon.svg";
import rightVector from "../../images/individual/right-vector.svg";
import benifitIcon from "../../images/individual/benifitIcon.png";
import { FaNewspaper, FaCalendarAlt, FaExternalLinkAlt, FaBriefcase, FaGraduationCap, FaVoteYea, FaArrowDown, FaCompass, FaUsers, FaChartBar, FaGlobe, FaClock, FaTag, FaArrowUp, FaArrowRight } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const News = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All News', icon: FaNewspaper },
    { id: 'migration', name: 'Migration Updates', icon: FaUsers },
    { id: 'employer', name: 'Employer Visas', icon: FaBriefcase },
    { id: 'student', name: 'Student Visas', icon: FaGraduationCap },
    { id: 'policy', name: 'Policy Changes', icon: FaVoteYea }
  ];

  const newsItems = [
    {
      id: 1,
      category: 'migration',
      date: '2024-25',
      title: 'Migration Program 2024–25: Focus on Skills and Regional Australia',
      excerpt: 'The Australian Government has set the permanent Migration Program planning levels at 185,000 places for 2024–25. Approximately 71% allocated to Skill stream...',
      content: 'The Australian Government has set the permanent Migration Program planning levels at 185,000 places for 2024–25. Approximately 71% of these places are allocated to the Skill stream, aiming to address labor shortages in critical sectors and prioritize visa processing for regional areas.',
      link: 'https://immi.homeaffairs.gov.au/what-we-do/migration-program-planning-levels',
      linkText: 'Immigration and citizenship Website',
      blogUrl: '/news/migration-program-2024-25',
      icon: FaArrowUp,
      featured: true
    },
    {
      id: 2,
      category: 'employer',
      date: '2024-25',
      title: 'Employer-Sponsored Visas: Increased Planning Levels',
      excerpt: 'The planning level for Employer-Sponsored visas has been increased to 44,000 visas for 2024–25, up from 36,825 in the previous year...',
      content: 'The planning level for Employer-Sponsored visas has been increased to 44,000 visas for 2024–25, up from 36,825 in the previous year. This expansion supports the government\'s initiative to provide a clearer pathway to permanent residency for temporary migrants, particularly through the Temporary Residence Transition Stream.',
      link: 'https://immi.homeaffairs.gov.au/what-we-do/migration-program-planning-levels',
      linkText: 'Immigration and citizenship Website',
      blogUrl: '/news/employer-sponsored-visas-2024-25',
      icon: FaBriefcase,
      featured: false
    },
    {
      id: 3,
      category: 'student',
      date: 'July 2024',
      title: 'International Student Visa Processing: New Prioritization System',
      excerpt: 'The government has introduced Ministerial Direction 111, implementing a two-tier processing system with 80% high priority and 20% standard priority...',
      content: 'In response to concerns over international student numbers, the government has introduced Ministerial Direction 111, effective from July 2024. This policy implements a two-tier processing system for offshore student visa applications: High Priority (80% of applications processed swiftly) and Standard Priority (remaining 20% processed at a slower pace).',
      link: 'https://www.theaustralian.com.au/subscribe/news/1/?sourceCode=TAWEB_WRE170_a&dest=https%3A%2F%2Fwww.theaustralian.com.au%2Feducation%2Fde-facto-student-cap-would-be-illegal-exbureaucrat-says-as-ministerial-direction-111-is-introduced%2Fnews-story%2F8d1b1376dfaa5116b038cf2c073f5684&memtype=anonymous&mode=premium&v21=GROUPB-Segment-1-NOSCORE&V21spcbehaviour=append',
      linkText: 'The Australian',
      additionalLinks: [
        { url: 'https://www.theguardian.com/australia-news/2024/dec/19/labor-australia-foreign-student-visa-cap-plan-new-policy-processing', text: 'The Guardian' }
      ],
      blogUrl: '/news/international-student-visa-processing-2024',
      icon: FaGraduationCap,
      featured: true
    },
    {
      id: 4,
      category: 'policy',
      date: '2025-26',
      title: 'Coalition\'s Migration Policy Proposal',
      excerpt: 'The Coalition has proposed reducing net overseas migration by 100,000 if elected, aiming to decrease permanent migration from 185,000 to 140,000...',
      content: 'The Coalition has proposed reducing net overseas migration by 100,000 if elected, aiming to decrease permanent migration from 185,000 in 2024–25 to 140,000 in 2025–26. However, they have clarified that working holiday visas will remain unaffected, acknowledging the essential role of backpackers in supporting regional industries like tourism, hospitality, and agriculture.',
      link: 'https://www.theguardian.com/australia-news/2025/apr/27/nationals-senator-bridget-mckenize-insists-coalition-wont-cut-working-holiday-visas',
      linkText: 'The Guardian',
      blogUrl: '/news/coalition-migration-policy-proposal',
      icon: FaVoteYea,
      featured: false
    },
    {
      id: 5,
      category: 'migration',
      date: '2026-27',
      title: 'Net Migration Forecasts',
      excerpt: 'The federal budget forecasts a decline in net overseas migration to 225,000 by 2026–27, down from a peak of 528,000 in 2022–23...',
      content: 'The federal budget forecasts a decline in net overseas migration to 225,000 by 2026–27, down from a peak of 528,000 in 2022–23. This reduction is part of the government\'s strategy to alleviate pressures on housing and infrastructure.',
      link: 'https://www.theaustralian.com.au/subscribe/news/1/?sourceCode=TAWEB_WRE170_a&dest=https%3A%2F%2Fwww.theaustralian.com.au%2Fnation%2Ffederal-budget-2025-labor-forecasts-net-migration-fall-to-225000-amid-rising-departures%2Fnews-story%2F1f00db75bf3460fb2b795d965ed0f7ae&memtype=anonymous&mode=premium&v21=GROUPB-Segment-1-NOSCORE&V21spcbehaviour=append',
      linkText: 'The Australian',
      blogUrl: '/news/net-migration-forecasts-2026-27',
      icon: FaArrowDown,
      featured: false
    },
    {
      id: 6,
      category: 'policy',
      date: 'December 2023',
      title: 'Immigration Strategy: A Vision for the Future',
      excerpt: 'The Australian Government\'s Migration Strategy outlines a vision for a more streamlined migration system with over 25 policy commitments...',
      content: 'The Australian Government\'s Migration Strategy, released in December 2023, outlines a vision for a more streamlined and responsive migration system. The strategy includes over 25 policy commitments aimed at simplifying visa processes, enhancing labor market matching, and addressing regional workforce needs.',
      link: 'https://immi.homeaffairs.gov.au/what-we-do/migration-strategy',
      linkText: 'Immigration and citizenship Website',
      blogUrl: '/news/immigration-strategy-vision-future',
      icon: FaCompass,
      featured: true
    }
  ];

  const filteredNews = selectedCategory === 'all' ? newsItems : newsItems.filter(item => item.category === selectedCategory);
  const featuredNews = newsItems.filter(item => item.featured);
  const regularNews = newsItems.filter(item => !item.featured);

  return (
    <div>
      <Helmet>
        <title>Immigration News Australia – Latest Updates & Policy Changes - Immiget Global</title>
        <meta
          name="description"
          content="Stay updated with latest Australian immigration news, policy changes, and visa updates. Migration program 2024-25, student visas, employer sponsorship & more."
        />
        <meta 
          name="keywords" 
          content="immigration news australia, migration updates, visa policy changes, student visa news, employer sponsored visas, australian migration program" 
        />
      </Helmet>
      
      <div className="w-full h-90 font-Hellix bg-cover bg-center bg-image">
        <div className="max-w-[1440px] px-4 md:px-[75px] m-auto h-full">
          <div className="flex flex-col gap-2 md:gap-2 pt-10 md:pt-20 pb-[90px] h-full justify-center">
            <div className="text-white hellix-font text-center font-semibold text-[22px] md:text-[54px]">
              Immigration News & Updates
            </div>
            <div className="flex justify-center gap-2 md:gap-4">
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium">
                HOME
              </div>
              <div className="flex items-center">
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
                <img src={arrowIcon} className="w-[5.8px] md:w-auto" alt="" />
              </div>
              <div className="text-white hellix-font text-[10px] lg:text-sm flex items-center md:text-lg font-medium uppercase">
                News
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
        <div className="text-center">
          <h1 className="xl:text-[30px] text-[24px] text-blue font-semibold hellix-font mb-4">
            Stay Informed with Immiget Global
          </h1>
          <p className="hellix-font text-blue text-lg xl:text-[20px] font-normal max-w-4xl mx-auto">
            At Immiget Global, we are committed to keeping you updated on the latest immigration policies and opportunities. Whether you're a skilled professional seeking to migrate, an employer looking to sponsor talent, or an international student planning your future in Australia, our team is here to guide you through the evolving immigration landscape.
          </p>
        </div>
      </div>

      <div className="container max-w-1440px mx-auto px-4 lg:px-14">
        <div style={{ border: "1px solid #cde1ea" }}></div>
      </div>

      {/* Category Filter */}
      <div className="container max-w-1440px mx-auto px-4 py-6 lg:px-14">
        <div className="flex gap-2 mb-6">
          <div className="flex items-center">
            <img src={benifitIcon} alt="benefits" />
          </div>
          <h2 className="lg:text-[28 px] text-2xl text-blue font-semibold hellix-font">
            Latest Immigration Updates
          </h2>
        </div>
        
        <div className="flex flex-wrap gap-3 mb-8">
          {categories.map((category) => {
            const IconComponent = category.icon;
            return (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full font-medium hellix-font transition-all duration-300 ${
                  selectedCategory === category.id
                    ? 'bg-blue text-white shadow-lg'
                    : 'bg-gray-100 text-blue hover:bg-blue-50'
                }`}
              >
                <IconComponent className="text-sm" />
                {category.name}
              </button>
            );
          })}
        </div>
      </div>

      {/* Featured News Section */}
      {selectedCategory === 'all' && (
        <div className="container max-w-1440px mx-auto px-4 py-6 lg:px-14">
          <h3 className="text-2xl text-blue font-semibold hellix-font mb-6 flex items-center gap-2">
            <FaTag className="text-blue" />
            Featured Updates
          </h3>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12">
            {featuredNews.slice(0, 2).map((item) => {
              const IconComponent = item.icon;
              return (
                <div key={item.id} className="bg-gradient-to-r from-blue-50 to-white rounded-lg p-6 shadow-custom-white border-l-4 border-blue">
                  <div className="flex items-start gap-4">
                    <div className="bg-blue text-white p-3 rounded-full flex-shrink-0">
                      <IconComponent className="text-xl" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <FaCalendarAlt className="text-blue text-sm" />
                        <span className="text-blue text-sm hellix-font font-medium">{item.date}</span>
                      </div>
                      <h4 className="text-blue text-xl font-semibold hellix-font mb-3 leading-tight">
                        {item.title}
                        <div className="w-full h-[2px] bg-blue mt-1"></div>
                      </h4>
                      <p className="text-blue hellix-font mb-4 leading-relaxed">
                        {item.content}
                      </p>
                      <div className="flex flex-wrap gap-3 mb-4">
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-1 text-blue font-medium hellix-font hover:text-blue-700 transition-colors text-sm"
                        >
                          {item.linkText}
                          <FaExternalLinkAlt className="text-xs" />
                        </a>
                        {item.additionalLinks && item.additionalLinks.map((link, index) => (
                          <a
                            key={index}
                            href={link.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1 text-blue font-medium hellix-font hover:text-blue-700 transition-colors text-sm"
                          >
                            {link.text}
                            <FaExternalLinkAlt className="text-xs" />
                          </a>
                        ))}
                      </div>
                      <Link
                        to={item.blogUrl}
                        className="inline-flex items-center gap-2 bg-blue text-white px-4 py-2 rounded-lg font-medium hellix-font hover:bg-blue-700 transition-colors text-sm"
                      >
                        Read Full Article
                        <FaArrowRight className="text-xs" />
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* All News Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 lg:px-14">
        <h3 className="text-2xl text-blue font-semibold hellix-font mb-6 flex items-center gap-2">
          <FaNewspaper className="text-blue" />
          {selectedCategory === 'all' ? 'All Updates' : `${categories.find(c => c.id === selectedCategory)?.name} Updates`}
        </h3>
        
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
          {filteredNews.map((item) => {
            const IconComponent = item.icon;
            return (
              <div key={item.id} className="bg-white rounded-lg shadow-custom-white hover:shadow-lg transition-all duration-300 overflow-hidden">
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="bg-blue-50 text-blue p-2 rounded-lg">
                      <IconComponent className="text-lg" />
                    </div>
                    <div>
                      <div className="flex items-center gap-1 text-blue text-sm hellix-font">
                        <FaClock className="text-xs" />
                        {item.date}
                      </div>
                    </div>
                  </div>
                  
                  <h4 className="text-blue text-lg font-semibold hellix-font mb-3 leading-tight">
                    {item.title}
                    <div className="w-full h-[2px] bg-blue mt-1"></div>
                  </h4>
                  
                  <p className="text-blue hellix-font mb-4 text-sm leading-relaxed">
                    {item.excerpt}
                  </p>
                  
                  <div className="space-y-2 mb-4">
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-blue font-medium hellix-font hover:text-blue-700 transition-colors text-sm"
                    >
                      {item.linkText}
                      <FaExternalLinkAlt className="text-xs" />
                    </a>
                    {item.additionalLinks && item.additionalLinks.map((link, index) => (
                      <a
                        key={index}
                        href={link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-blue font-medium hellix-font hover:text-blue-700 transition-colors text-sm block"
                      >
                        {link.text}
                        <FaExternalLinkAlt className="text-xs" />
                      </a>
                    ))}
                  </div>
                  
                  <Link
                    to={item.blogUrl}
                    className="inline-flex items-center gap-2 bg-blue text-white px-3 py-2 rounded-lg font-medium hellix-font hover:bg-blue-700 transition-colors text-sm w-full justify-center"
                  >
                    Read More
                    <FaArrowRight className="text-xs" />
                  </Link>
                </div>
                
                {item.featured && (
                  <div className="bg-gradient-to-r from-blue to-blue-600 px-6 py-2">
                    <span className="text-white text-xs hellix-font font-medium">Featured Update</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Newsletter Subscription CTA */}
      <div className="container max-w-1440px mx-auto px-4 py-8 lg:px-14">
        <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg p-8 text-center">
          <div className="flex justify-center mb-4">
            <div className="bg-blue text-white p-4 rounded-full">
              <FaNewspaper className="text-2xl" />
            </div>
          </div>
          <h3 className="text-2xl text-blue font-bold hellix-font mb-4">
            Stay Updated with Immigration News
          </h3>
          <p className="text-blue text-lg hellix-font mb-6 max-w-2xl mx-auto">
            Get the latest immigration updates, policy changes, and opportunities delivered straight to your inbox. Our expert team analyzes every change to help you make informed decisions.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center max-w-md mx-auto">
            <input
              type="email"
              placeholder="Enter your email address"
              className="flex-1 px-4 py-3 rounded-lg border border-blue-200 focus:outline-none focus:ring-2 focus:ring-blue-500 hellix-font"
            />
            <button className="px-6 py-3 bg-blue text-white font-semibold hellix-font rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap">
              Subscribe Now
            </button>
          </div>
        </div>
      </div>

      {/* Quick Links Section */}
      <div className="container max-w-1440px mx-auto px-4 py-6 lg:px-14">
        <div className="bg-white rounded-lg shadow-custom-white p-6">
          <h3 className="text-xl text-blue font-semibold hellix-font mb-4 flex items-center gap-2">
            <FaGlobe className="text-blue" />
            Official Immigration Resources
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { name: 'Department of Home Affairs', url: 'https://immi.homeaffairs.gov.au/' },
              { name: 'Migration Program Planning', url: 'https://immi.homeaffairs.gov.au/what-we-do/migration-program-planning-levels' },
              { name: 'Australian Migration Strategy', url: 'https://immi.homeaffairs.gov.au/what-we-do/migration-strategy' }
            ].map((link, index) => (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 p-3 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
              >
                <FaExternalLinkAlt className="text-blue text-sm" />
                <span className="text-blue hellix-font font-medium">{link.name}</span>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <Contact />
    </div>
  );
};

export default News;